package com.milta.core.localization.translations.ro

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Livrare nouă",
    manualDeliverySubtitle = "Adăugați o livrare la traseu",
    recipientNameLabel = "Numele destinatarului",
    addressLabel = "Adresă",
    phoneNumberLabel = "Telefon",
    deliveryTimeLimitLabel = "Ora limită",
    optionalSuffix = "(opțional)",
    submitButton = "Adaugă livrarea",
    saveEditedDeliveryButton = "Salvează modificarea",
    deliveryCreated = "Livrare adăugată",
    errorRecipientNameRequired = "Numele destinatarului este obligatoriu",
    errorRecipientNameTooLong = "Numele este prea lung (max. 150 de caractere)",
    errorAddressRequired = "Adresa este obligatorie",
    errorAddressTooLong = "Adresa este prea lungă (max. 255 de caractere)",
    errorPhoneTooLong = "Telefonul este prea lung (max. 20 de caractere)",
    errorDuplicateDelivery = "Această livrare este deja în listă (același destinatar și aceeași adresă)",
    errorRouteNotFound = "Traseul nu a fost găsit",
    errorForbidden = "Nu aveți permisiunea de a edita acest traseu",
    errorValidation = "Vă rugăm să verificați câmpurile introduse",
    errorGeneric = "A apărut o eroare. Încercați din nou.",
    errorRouteNotInProgress = "Acest traseu nu mai este în curs. Nu se poate adăuga o livrare.",
    unknownRecipientLabel = "Necunoscut",
    driverHomeTitle = "Traseul meu",
    driverModeBadge = "Mod livrator",
    routeStatusScheduled = "Programat",
    routeStatusInProgress = "În curs",
    routeStatusCompleted = "Finalizat",
    stopsCountLabel = "opriri",
    startRouteButton = "Începe traseul",
    noRouteTitle = "Niciun traseu",
    noRouteSubtitle = "Niciun traseu nu vă este atribuit momentan.",
    noRoutePastSubtitle = "Niciun traseu nu v-a fost atribuit pentru această dată.",
    routeInProgressTitle = "Traseu în curs",
    routeCompletedTitle = "Traseu finalizat",
    deliveriesSectionTitle = "Livrări",
    addStopButton = "Adaugă o oprire",
    errorConflict = "Traseul a fost deja început sau finalizat.",
    greetingPrefix = "Bună",
    routeOfTheDayLabel = "TURUL DE AZI",
    noOtherRouteLabel = "Nicio altă tură planificată",
    routeLabel = "Tură",
    importMenuTitle = "Importă livrări",
    importMenuSubtitle = "Mai multe moduri combinabile — alegeți o sursă",
    importModePhotoPaperTitle = "Foto — listă pe hârtie",
    importModePhotoPaperDesc = "Fotografiați o foaie scrisă de mână sau tipărită",
    importModePhotoLabelTitle = "Foto — etichetă colet",
    importModePhotoLabelDesc = "Scanați eticheta lipită pe un colet",
    importModePdfTitle = "Importă un PDF",
    importModePdfDesc = "Avize de livrare, fișier scanat",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Formatul dvs. — coloanele sunt detectate automat",
    importModeManualTitle = "Introducere manuală",
    importModeManualDesc = "Nume, adresă, telefon, oră limită",
    createRouteTitle = "Creează o tură",
    createRouteEmptyDrivers = "Niciun șofer în echipa dvs. momentan",
    editDeliveriesAction = "Editează",
    moreDeliveriesLabel = "altele",
    addDeliveriesAction = "Adaugă livrări",
    assignToTitle = "Atribuie lui",
    optimizeRouteButton = "Optimizează traseul",
    createRouteButtonNoOptimize = "Creează traseul",
    errorNoEnterprise = "Nicio companie asociată contului dvs.",
    errorDriverNotFound = "Șofer negăsit",
    errorNoDeliveries = "Adăugați cel puțin o livrare înainte de a optimiza traseul",
    errorOptimizationUnavailable = "Serviciul de optimizare este temporar indisponibil.",
    errorGeocodingFailed = "Unele adrese de livrare nu au putut fi localizate. Editați adresa și încercați din nou.",
    dispatchTitle = "Optimizare",
    optimizedSuccessTitle = "Traseu optimizat!",
    optimizedSuccessSubtitleSuffix = "opriri ordonate pentru cel mai scurt traseu",
    stopsStatLabel = "Opriri",
    driverAvailableStatus = "Disponibil",
    sendRouteButtonPrefix = "Trimite tura lui",
    errorRouteAlreadyDispatched = "Tura a fost deja trimisă.",
    stopDetailTitlePrefix = "Oprire",
    stopStatusCurrentLabel = "În curs",
    stopStatusUpcomingLabel = "Viitoare",
    stopStatusDeliveredLabel = "Livrat",
    stopStatusFailedLabel = "Eșuat",
    stopRecipientLabel = "Destinatar",
    callActionLabel = "Sună",
    noPhoneLabel = "Telefon nespecificat",
    packagesCountLabel = "colete",
    navigateButton = "Navighează",
    deadlineBeforePrefix = "Înainte de",
    deadlinePastSuffix = "depășit",
    validateStopAction = "Validează acest stop",
    teamDashboardTitle = "Trasee",
    todayDateLabel = "Astăzi",
    liveBadgeLabel = "Live",
    statRoutesLabel = "Trasee",
    statDeliveriesLabel = "Livrări",
    statCompletedLabel = "Finalizate",
    teamSectionTitle = "Echipă",
    routeStartedAtPrefix = "Început la",
    routeCompletedAtPrefix = "Finalizat la",
    routeNotStartedLabel = "Neînceput",
    emptyTeamRoutesTitle = "Niciun traseu în această zi",
    emptyTeamRoutesSubtitle = "Niciun șofer din echipă nu are un traseu planificat pentru această dată.",
    errorInvalidDate = "Dată nevalidă",
    routeDetailTitle = "Detaliu traseu",
    driverEyebrowLabel = "Șofer",
    failedDeliveryTag = "Livrare eșuată",
    driverLoadingCheckTitle = "Verificarea încărcării",
    loadingCheckInstructionText = "Verificați dacă toate coletele prevăzute sunt încărcate în vehicul înainte de a porni la drum.",
    expectedPackagesLabel = "colete prevăzute pentru această tură",
    confirmLoadCheckboxPrefix = "Am încărcat cele",
    confirmLoadCheckboxSuffix = "colete prevăzute pentru această tură",
    reportDiscrepancyToggleLabel = "Semnalează o discrepanță",
    discrepancyNotePlaceholder = "Ex.: am încărcat 9 colete în loc de 11…",
    discrepancyNoteTooLong = "Notă prea lungă — maximum 500 de caractere.",
    undeliveredStopsSectionTitle = "Colete neridicate — eliminați din tură",
    removedStopNoticePrefix = "„",
    removedStopNoticeMiddle = "” eliminat din tură — o oprire mai puțin",
    remainingStopsSuffix = "rămase",
    confirmAndStartButton = "Confirmă și pornește tura",
    loadingOnBehalfOfLabel = "În numele",
    loadingExpectedLabel = "Încărcare prevăzută",
    loadingQuestionTitle = "Ați încărcat toate coletele?",
    loadingAllLoadedPrefix = "Da, toate cele",
    loadingAllLoadedSuffix = "colete sunt la bord",
    loadingIncompleteOption = "Încărcare incompletă",
    loadingIncompleteHint = "Elimin opririle afectate sau justific",
    loadingIncompleteRemoveLabel = "Și/sau eliminați opririle neîncărcate",
    slideToStartLabel = "Glisați pentru a porni",
    completeRouteButton = "Finalizează traseul",
    completeRouteDialogTitle = "Finalizați traseul?",
    completeRouteDialogPendingCountSuffix = "livrări nu au fost încă procesate",
    completeRouteDialogPendingNote = "Acestea vor fi marcate ca netratate.",
    completeRouteDialogBody = "Această acțiune este definitivă: traseul va trece în starea „Finalizat” și nu va mai putea fi modificat.",
    completeRouteDialogBodyAllTreated = "Toate livrările au fost procesate. Traseul va trece în starea „Finalizat” și nu va mai putea fi modificat.",
    completeRouteDialogConfirm = "Finalizează",
    routeCompletedMessage = "Traseu finalizat.",
    stopStatusUntreatedLabel = "Netratat",
    errorCompleteRouteStatusConflict = "Acest traseu nu poate fi finalizat în starea sa actuală.",
    errorCompleteRoutePendingStopsConflict = "Unele livrări sunt încă în așteptare. Confirmați pentru a finaliza oricum.",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Număr de colete",
    newStopBadgeLabel = "NOU",
    reoptimizeResultTitle = "Traseu nou",
    reoptimizeSuccessTitle = "Traseu reoptimizat",
    reoptimizeSuccessSubtitleSuffix = "oprire adăugată și repoziționată pentru cel mai scurt traseu.",
    reoptimizeFallbackTitle = "Oprire adăugată, reoptimizare indisponibilă",
    reoptimizeFallbackSubtitle = "Serviciul de optimizare este temporar indisponibil. Noua oprire a fost adăugată la finalul listei.",
    addedStatLabel = "Adăugat",
    backToRouteButton = "Înapoi la traseu",
    routeBatchMultiDriverLink = "Distribuie între mai mulți șoferi",
    routeBatchSelectTitle = "Distribuie cursa",
    routeBatchDeliveriesReadyLabel = "livrări gata de distribuit",
    routeBatchDriversSectionTitle = "Șoferi",
    routeBatchDriversSelectedSuffix = "șoferi selectați",
    routeBatchOptimizeToggleTitle = "Optimizează traseul",
    routeBatchOptimizeToggleHelp = "RoutaR distribuie și ordonează opririle în funcție de distanță. Dezactivat: distribuție egală simplă după numărul de opriri, fără calcul de traseu.",
    routeBatchSubmitButtonPrefix = "Distribuie între",
    routeBatchDriversWord = "șoferi",
    routeBatchOptimizationUnavailable = "Serviciul de optimizare este temporar indisponibil. Cursa nu a fost creată — verificați conexiunea și reîncercați, sau dezactivați „Optimizează traseul” pentru o distribuție simplă imediată.",
    routeBatchPreviewTitle = "Previzualizarea distribuției",
    routeBatchPreviewEyebrowMiddle = "livrări distribuite între",
    routeBatchPreviewEyebrowSuffix = "șoferi",
    routeBatchStopsChipSuffix = "opriri",
    routeBatchDistanceLabel = "Distanță",
    routeBatchDurationLabel = "Durată estimată",
    routeBatchDistanceNotCalculated = "Necalculată",
    routeBatchOptimizeDisabledBanner = "Optimizare dezactivată: distribuție egală după numărul de opriri, fără calcul de distanță sau ordine.",
    routeBatchReoptimizeButton = "Reoptimizează",
    routeBatchDispatchButton = "Confirmă și trimite",
    errorRouteBatchAlreadyDispatched = "Acest lot a fost deja trimis șoferilor — nu mai poate fi modificat.",
    routeBatchDispatchedTitle = "Curse trimise!",
    routeBatchDispatchedSubtitleSuffix = "șoferi notificați simultan, fiecare cu propria cursă programată.",
    routeBatchStatRoutesLabel = "Curse",
    routeBatchStatDeliveriesLabel = "Livrări",
    routeBatchStatusLabel = "Status",
    routeBatchStatusDispatchedValue = "Trimisă",
    routeBatchSentAtLabel = "Trimis pe",
    routeBatchPerDriverTitle = "Detalii pe șofer",
    routeBatchDriverScheduledStatus = "Programată",
    routeBatchBackToHomeButton = "Înapoi la ecranul principal",
    errorTooManyDrivers = "Nu puteți selecta mai mult de 50 de șoferi simultan.",
    errorTooManyDeliveries = "Un lot nu poate depăși 500 de livrări.",
    createRouteFabLabel = "Tură nouă",
    createOwnRouteButtonLabel = "Creează / optimizează cursa mea",
    createOwnRouteTitle = "Creează cursa mea",
    createOwnRouteDeliveriesCountSuffix = "livrări gata",
    stopStatusEnRouteLabel = "În drum",
    yesterdayDateLabel = "Ieri",
    periodPastLabel = "Trecut",
    periodTomorrowLabel = "Mâine",
    viewRouteButton = "Vezi traseul",
    viewButton = "Vezi",
    noRouteTomorrowTitle = "Nimic planificat pentru mâine",
    noRouteTomorrowSubtitle = "Planifică o tură din timp pentru a o avea gata chiar de mâine dimineață.",
    planRouteButtonLabel = "Planifică o tură",
    myRoutesTodayTitle = "Turele tale de azi",
    myRoutesTitle = "Turele tale",
    weekdayShortNames = listOf("Lun", "Mar", "Mie", "Joi", "Vin", "Sâm", "Dum"),
    weekdayFullNames = listOf("Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă", "Duminică"),
    monthNames = listOf("ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"),
    statRoutesTodayLabel = "Ture azi",
    statStopsTodayLabel = "Opriri azi",
    statOnTimeLabel = "La timp azi",
    statAvgProgressLabel = "Progres mediu",
    inProgressSectionTitle = "În desfășurare",
    upcomingSectionTitle = "Următoarele",
    doneSectionTitle = "Finalizate",
    seeAllLabel = "Vezi tot",
    continueRouteButton = "Continuă tura",
    detailsLinkLabel = "Detalii",
    deliveryProofTitle = "Validează livrarea",
    deliveryProofStatusSectionLabel = "Statutul livrării",
    deliveryProofPhotoSectionLabel = "Fotografie doveditoare",
    deliveryProofPhotoHint = "Obligatorie pentru validare",
    deliveryProofTakePhotoCta = "Fă o fotografie",
    deliveryProofRetakePhotoCta = "Refă fotografia",
    deliveryProofRetakeChipLabel = "Reia",
    deliveryProofCommentSectionLabel = "Comentariu",
    deliveryProofCommentRequiredSuffix = "obligatoriu în caz de eșec",
    deliveryProofCommentPlaceholderOptional = "Opțional — detalii despre livrare…",
    deliveryProofCommentPlaceholderRequired = "Explicați motivul eșecului…",
    deliveryProofCommentRequiredError = "Un comentariu este obligatoriu în caz de livrare eșuată",
    deliveryProofSubmitButton = "Validează livrarea",
    deliveryProofErrorInvalidPhoto = "Fotografie ilizibilă sau format neacceptat. Refaceți fotografia și încercați din nou.",
    deliveryProofAlreadyProcessedBanner = "Acest punct a fost deja procesat și nu mai poate fi modificat.",
    deliveryConfirmTitle = "Livrare validată",
    deliveryConfirmSuccessTitle = "Livrare confirmată",
    deliveryConfirmSuccessSubtitle = "Dovada a fost înregistrată pentru acest punct.",
    deliveryConfirmFailedTitle = "Eșec înregistrat",
    deliveryConfirmFailedSubtitle = "Comentariul și fotografia au fost trimise managerului.",
    deliveryConfirmRouteCompletedTitle = "Tură finalizată!",
    deliveryConfirmRouteCompletedSubtitle = "Toate punctele au fost procesate.",
    deliveryConfirmValidatedAtLabel = "Validat la",
    deliveryConfirmNextStopEyebrowPrefix = "Punctul următor",
    deliveryConfirmGoToNextStopButton = "Mergi la punctul următor",
    deliveryConfirmAllDoneMessage = "Acesta a fost ultimul punct al turei — nu uitați să o închideți.",
    offlineBannerTitle = "Fără conexiune",
    offlineBannerRouteSubtitle = "validările dvs. vor fi trimise imediat ce revine rețeaua",
    offlineBannerValidateSubtitle = "va fi salvată local",
    offlineSyncingBannerTitle = "Sincronizare în curs",
    offlineSyncingSubtitleSuffix = "livrări trimise",
    offlineRetryBannerTitle = "Sincronizare eșuată",
    offlineRetryBannerSubtitle = "o nouă încercare la următoarea conexiune la rețea",
    offlineSyncSuccessToastSuffix = "livrări sincronizate cu succes",
    offlineQueuedBadgePendingLabel = "În așteptarea trimiterii",
    offlineQueuedBadgeSyncingLabel = "Se trimite",
    offlineQueuedBadgeFailedLabel = "Eșuat — reîncercare programată",
    offlineQueuedBadgeConflictLabel = "Deja gestionat în altă parte",
    offlineDismissConflictAction = "Renunță",
    offlineValidatedLocallyAtPrefix = "validat local la",
    offlineAddStopRequiresConnectionSuffix = "(necesită o conexiune)",
    deliveryProofOfflineSubmitButton = "Salvează (sincronizare ulterioară)",
    deliveryProofSavedLocallyTitle = "Salvat local",
    deliveryProofSavedLocallySubtitle = "Această livrare va fi trimisă automat imediat ce conexiunea este restabilită.",
    routeScheduledBannerTitle = "Cursa nu a început încă",
    routeScheduledBannerSubtitle = "Porniți cursa pentru a putea valida o livrare.",
    geocodeIssueTag = "Adresă nelocalizată",
    regeocodeAction = "Reîncearcă geolocalizarea",
    regeocodeSuccessMessage = "Adrese actualizate",
    dashboardTitle = "Dashboard",
    viewAllAction = "Vezi tot",
    deleteRouteDialogTitle = "Ștergeți traseul?",
    deleteRouteDialogMessage = "Acest traseu va fi șters definitiv. Această acțiune este ireversibilă.",
    errorRouteDeleteConflict = "Ștergere indisponibilă: traseul este în curs de desfășurare.",
    errorDriverHasActiveRoute = "Un alt traseu este momentan în curs. Finalizați-l înainte de a-l începe pe acesta.",
    dashboardLiveBadge = "În direct",
    routeBatchNoStopsTag = "Fără opriri",
    routeBatchNoStopsDialogTitle = "Șofer fără opriri",
    routeBatchNoStopsDialogMessage = "Cel puțin un șofer nu are nicio oprire atribuită. Va primi totuși o cursă goală dacă nu este eliminat din acest lot. Trimiteți oricum?",
    ),
)
